import React, { useContext, useEffect, useState } from "react";
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";
import "./PagamentosCliente.css";
import { Button, Table, Select, Input, Radio } from "antd";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import { DatePicker } from "antd";
import "antd/dist/antd.css";
import * as links from "../../../../utils/links";
import { Form } from "react-bootstrap";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const PagamentosCliente = (props) => {

  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
  const { dataUser } = authInfo;

  let navigate = useNavigate();
  const token = authInfo?.dataUser?.token;

  const [isLoading, setIsLoading] = useState(false);
  const [listCanals, setListCanals] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [total, setTotal] = useState("");
  const [loadingTable, setLoadingTable] = useState(false);
  const [filtro, setFiltro] = useState("mesatual");
  const [modoResumo, setModoResumo] = useState("maquina");
  const [maquina, setMaquina] = useState({
    id: '',
    nome: ''
  })
  const [dataInicio, setDataInicio] = useState(null);
  const [dataFim, setDataFim] = useState(null);
  const [maquinas, setMaquinas] = useState([])
  const [totais, setTotais] = useState({
    especie: 0,
    pix: 0,
    debito: 0,
    credito: 0,
    quantidade: 0,
    totalGeral: 0,
    totalBruto: 0,
    totalLiquido: 0,
    totalEstorno: 0
  });
  const [taxas, setTaxas] = useState({
    PIX: 0,
    CREDITO: 0,
    DEBITO: 0,
  });
  const [totaisTodasMaquinas, setTotaisTodasMaquinas] = useState({
    especie: 0,
    pix: 0,
    debito: 0,
    credito: 0,
  });
  const [taxasTodasMaquinas, setTaxasTodasMaquinas] = useState({
    PIX: 0,
    CREDITO: 0,
    DEBITO: 0,
  });
  const [loadingTotaisTodasMaquinas, setLoadingTotaisTodasMaquinas] = useState(false);

  const { RangePicker } = DatePicker;

  useEffect(() => {
    buscaMaquinas()
  }, []);

  useEffect(() => {
    if (filtro === "periodo") {
      setNotiMessage({
        type: "info",
        message:
          "Selecione o período de datas para busca.",
      });
      // Mantém as datas atuais ou limpa se necessário
    } else if (filtro === "hoje") {
      const hoje = moment().format("YYYY-MM-DD");
      setDataInicio(hoje);
      setDataFim(hoje);
    } else if (filtro === "mesatual") {
      const start = moment().startOf('month').format('YYYY-MM-DD');
      const end = moment().format('YYYY-MM-DD');
      setDataInicio(start);
      setDataFim(end);
    } else if (filtro === "mespassado") {
      const start = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
      const end = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
      setDataInicio(start);
      setDataFim(end);
    }
    // else {
    //   getData(filtro);
    // }
  }, [filtro]);

  // useEffect(() => {
  //   if (dataFim != null) {
  //     getData(filtro);
  //   }
  // }, [dataFim]);

  const buscaMaquinas = () => {
    setIsLoading(true);
    axios.get(`${process.env.REACT_APP_SERVIDOR}/maquinas`, {
      headers: {
        "x-access-token": token,
        "content-type": "application/json",
      },
    }).then((res) => {
      if (res.status === 200) {
        setIsLoading(false);
        setMaquinas(res.data);
      } else {
        throw new Error();
      }
    }).catch((err) => {
      setIsLoading(false);
      if ([401, 403].includes(err.response.status)) {
        setNotiMessage({
          type: "error",
          message:
            "A sua sessão expirou, para continuar faça login novamente.",
        });
        navigate(links.SIGNIN)
        setDataUser(null);
      }
    });
  };

  const buildPaymentsClientUrl = ({ filtro, maquinaId }) => {
    let backendFiltro = filtro;
    if (filtro === "hoje" || filtro === "mesatual" || filtro === "mespassado") {
      backendFiltro = "periodo";
    }

    let url = `${process.env.REACT_APP_SERVIDOR}/payments-client?filtro=${backendFiltro.toLowerCase()}&maquinaId=${maquinaId}`;

    if (dataInicio && (filtro === "periodo" || backendFiltro === "periodo")) {
      url += `&dataInicio=${encodeURIComponent(
        moment(dataInicio).startOf("day").toISOString()
      )}`;
    }

    if (dataFim && (filtro === "periodo" || backendFiltro === "periodo")) {
      url += `&dataFim=${encodeURIComponent(
        moment(dataFim).toISOString()
      )}`;
    }
    console.log(moment(dataInicio).startOf("day").toISOString())
    console.log(moment(dataFim).toISOString())

    return url;
  };

  const pieOptionsAllMachines = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      datalabels: {
        color: "rgba(233, 242, 255, 0.92)",
        font: { weight: "bold", size: 12 },
        formatter: (value, context) => {
          const data = context?.chart?.data?.datasets?.[0]?.data || [];
          const total = data.reduce((acc, v) => acc + (Number(v) || 0), 0);
          const pct = total ? ((Number(value) || 0) / total) * 100 : 0;
          if (!pct) return "";
          return `${pct.toFixed(1)}%`;
        },
      },
      legend: {
        display: true,
        position: "right",
        labels: { boxWidth: 10, color: "rgba(233, 242, 255, 0.85)" },
      },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const dataset = ctx.dataset.data || [];
            const sum = dataset.reduce((a, b) => a + b, 0);
            const val = ctx.raw || 0;
            const pct = sum ? ((val / sum) * 100).toFixed(1) : 0;
            const fmt = (n) =>
              new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(n || 0);
            return `${ctx.label}: ${pct}% (${fmt(val)})`;
          },
        },
      },
    },
  };

  const getPieChartDataAllMachines = () => ({
    labels: ["PIX", "Espécie", "Crédito", "Débito"],
    datasets: [
      {
        data: [
          Number(totaisTodasMaquinas.pix) || 0,
          Number(totaisTodasMaquinas.especie) || 0,
          Number(totaisTodasMaquinas.credito) || 0,
          Number(totaisTodasMaquinas.debito) || 0,
        ],
        backgroundColor: ["#2b6cb0", "#805ad5", "#38a169", "#dd6b20"],
        borderColor: ["#1e4f82", "#5b3b99", "#2a7a4d", "#a24d16"],
        borderWidth: 1,
      },
    ],
  });

  const filtrarPagamentosPorPeriodo = (pagamentos = []) => {
    if (!Array.isArray(pagamentos)) return [];
    if (!dataInicio || !dataFim) return pagamentos;

    const inicio = moment(dataInicio).startOf("day");
    const fim = moment(dataFim).endOf("day");

    return pagamentos.filter((pagamento) => {
      if (!pagamento?.data) return false;
      const dataPagamento = moment(pagamento.data);
      if (!dataPagamento.isValid()) return false;
      return dataPagamento.isBetween(inicio, fim, undefined, "[]");
    });
  };

  const resumirPagamentos = (pagamentos = []) => {
    if (!Array.isArray(pagamentos)) {
      return { totalBruto: 0, totalTaxas: 0, totalLiquido: 0 };
    }

    return pagamentos.reduce(
      (acc, pagamento) => {
        acc.totalBruto += Number(pagamento?.valor) || 0;
        acc.totalTaxas += Number(pagamento?.taxas) || 0;
        acc.totalLiquido = acc.totalBruto - acc.totalTaxas;
        return acc;
      },
      { totalBruto: 0, totalTaxas: 0, totalLiquido: 0 }
    );
  };

  const isResumoTodasMaquinasCompativel = () => Boolean(dataInicio && dataFim);

  const buildPeriodoRequestBody = () => {
    if (!isResumoTodasMaquinasCompativel()) return null;

    return {
      dataInicio: moment(dataInicio).startOf("day").toISOString(),
      dataFim: moment(dataFim).endOf("day").toISOString(),
    };
  };

  const shouldIgnoreResumoPagamento = (pagamento) => {
    const tipo = String(pagamento?.tipo || "").trim().toLowerCase();
    const mercadoPagoId = String(pagamento?.mercadoPagoId || "").trim().toLowerCase();

    return tipo === "saida_produto" || tipo === "saiu premio" || mercadoPagoId === "saiu premio";
  };

  const getResumoPeriodoPorMaquina = async (machineId) => {
    const requestBody = buildPeriodoRequestBody();
    if (!requestBody) return null;

    const response = await axios.post(
      `${process.env.REACT_APP_SERVIDOR}/pagamentos-periodo/${machineId}`,
      requestBody,
      {
        headers: {
          "x-access-token": token,
          "content-type": "application/json",
        },
      }
    );

    return response?.data || null;
  };

  const getResumoTodasMaquinas = async (filtro) => {
    const ids = Array.isArray(maquinas) ? maquinas.map((m) => m?.id).filter(Boolean) : [];
    if (!ids.length) {
      setTotaisTodasMaquinas({ especie: 0, pix: 0, debito: 0, credito: 0 });
      return;
    }

    setLoadingTotaisTodasMaquinas(true);
    try {
      if (!isResumoTodasMaquinasCompativel()) {
        setTotaisTodasMaquinas({ especie: 0, pix: 0, debito: 0, credito: 0 });
        return;
      }

      const responses = await Promise.all(
        ids.map((machineId) => getResumoPeriodoPorMaquina(machineId))
      );

      const sums = responses.reduce(
        (acc, d) => {
          acc.pix += Number(d?.totalPix) || 0;
          acc.credito += Number(d?.totalCartaoCredito) || 0;
          acc.debito += Number(d?.totalCartaoDebito) || 0;
          acc.especie += Number(d?.cash ?? d?.totalCash) || 0;
          return acc;
        },
        { especie: 0, pix: 0, debito: 0, credito: 0 }
      );

      setTotaisTodasMaquinas(sums);
    } catch (err) {
      setTotaisTodasMaquinas({ especie: 0, pix: 0, debito: 0, credito: 0 });
    } finally {
      setLoadingTotaisTodasMaquinas(false);
    }
  };

  const normalizeTipoTaxa = (tipo) => {
    const tipoValue = String(tipo || "").trim().toLowerCase();
    return tipoValue === "bank_transfer" || tipoValue === "11" || tipoValue === "account_money" || tipoValue === "conta mercado pago" || tipoValue === "pix"
      ? "PIX"
      : tipoValue === "debit_card" || tipoValue === "8"
        ? "DEBITO"
        : tipoValue === "credit_card" || tipoValue === "prepaid_card" || tipoValue === "1"
          ? "CREDITO"
          : null;
  };

  const calcularTaxasPorTipo = (pagamentos) => {
    const initial = { PIX: 0, CREDITO: 0, DEBITO: 0 };
    if (!Array.isArray(pagamentos)) return initial;

    return pagamentos.reduce((acc, p) => {
      const t = normalizeTipoTaxa(p?.tipo);
      if (!t) return acc;
      const v = Number(p?.taxas) || 0;
      acc[t] += v;
      return acc;
    }, initial);
  };

  const getDataTodasMaquinas = async (filtro) => {
    const ids = Array.isArray(maquinas) ? maquinas.map((m) => m?.id).filter(Boolean) : [];
    if (!ids.length) {
      setTotal(0);
      setTotais({
        especie: 0,
        pix: 0,
        debito: 0,
        credito: 0,
        quantidade: 0,
        totalGeral: 0,
        totalBruto: 0,
        totalLiquido: 0,
        totalEstorno: 0,
      });
      setTotaisTodasMaquinas({ especie: 0, pix: 0, debito: 0, credito: 0 });
      setTaxas({ PIX: 0, CREDITO: 0, DEBITO: 0 });
      setTaxasTodasMaquinas({ PIX: 0, CREDITO: 0, DEBITO: 0 });
      setListCanals([]);
      return;
    }

    setLoadingTable(true);
    try {
      if (!isResumoTodasMaquinasCompativel()) {
        setLoadingTable(false);
        return;
      }

      const responses = await Promise.all(
        ids.map(async (machineId) => {
          const resumo = await getResumoPeriodoPorMaquina(machineId);
          const machine = maquinas.find((m) => String(m?.id) === String(machineId));
          return { resumo, machine };
        })
      );

      const agg = responses.reduce(
        (acc, entry) => {
          const d = entry?.resumo || {};
          acc.pix += Number(d.totalPix) || 0;
          acc.credito += Number(d.totalCartaoCredito) || 0;
          acc.debito += Number(d.totalCartaoDebito) || 0;
          acc.especie += Number(d.cash ?? d.totalCash) || 0;
          acc.quantidade += Number(d.qtd) || 0;
          acc.totalGeral += Number(d.total) || 0;
          acc.totalBruto += Number(d.totalBruto) || 0;
          acc.totalLiquido += Number(d.totalLiquido) || 0;
          acc.totalEstorno += Number(d.estornos) || 0;
          acc.taxaPix += Number(d.taxaPix) || 0;
          acc.taxaCredito += Number(d.taxaCartaoCredito) || 0;
          acc.taxaDebito += Number(d.taxaCartaoDebito) || 0;
          return acc;
        },
        {
          especie: 0,
          pix: 0,
          debito: 0,
          credito: 0,
          quantidade: 0,
          totalGeral: 0,
          totalBruto: 0,
          totalLiquido: 0,
          totalEstorno: 0,
          taxaPix: 0,
          taxaCredito: 0,
          taxaDebito: 0,
        }
      );

      const pagamentosRecentes = responses
        .flatMap((entry) => {
          const pagamentos = Array.isArray(entry?.resumo?.pagamentos) ? entry.resumo.pagamentos : [];
          const machine = entry?.machine || {};

          return pagamentos
            .filter((pagamento) => !shouldIgnoreResumoPagamento(pagamento))
            .map((pagamento) => ({
              ...pagamento,
              maquinaNome: machine?.nome || "Sem nome",
              maquinaDescricao: machine?.descricao || "Sem descrição",
            }));
        })
        .filter(Boolean)
      const pagamentosFiltrados = filtrarPagamentosPorPeriodo(pagamentosRecentes)
        .sort((a, b) => new Date(b?.data || 0).getTime() - new Date(a?.data || 0).getTime());

      setTotal(Number(agg.totalGeral) || 0);
      setTotais({
        especie: agg.especie,
        pix: agg.pix,
        debito: agg.debito,
        credito: agg.credito,
        quantidade: agg.quantidade,
        totalGeral: agg.totalGeral,
        totalBruto: Number(agg.totalBruto) || 0,
        totalLiquido: Number(agg.totalLiquido) || 0,
        totalEstorno: Number(agg.totalEstorno) || 0,
      });
      setTotaisTodasMaquinas({ especie: agg.especie, pix: agg.pix, debito: agg.debito, credito: agg.credito });
      setTaxas({
        PIX: Number(agg.taxaPix) || 0,
        CREDITO: Number(agg.taxaCredito) || 0,
        DEBITO: Number(agg.taxaDebito) || 0,
      });
      setTaxasTodasMaquinas({
        PIX: Number(agg.taxaPix) || 0,
        CREDITO: Number(agg.taxaCredito) || 0,
        DEBITO: Number(agg.taxaDebito) || 0,
      });
      setListCanals(pagamentosFiltrados);
    } catch (err) {
      setTotal(0);
      setTotais({
        especie: 0,
        pix: 0,
        debito: 0,
        credito: 0,
        quantidade: 0,
        totalGeral: 0,
        totalBruto: 0,
        totalLiquido: 0,
        totalEstorno: 0,
      });
      setTotaisTodasMaquinas({ especie: 0, pix: 0, debito: 0, credito: 0 });
      setTaxas({ PIX: 0, CREDITO: 0, DEBITO: 0 });
      setTaxasTodasMaquinas({ PIX: 0, CREDITO: 0, DEBITO: 0 });
      setListCanals([]);
    } finally {
      setLoadingTable(false);
    }
  };

  const getData = (filtro) => {
    const url = buildPaymentsClientUrl({ filtro, maquinaId: maquina.id });
    setLoadingTable(true);
    axios
      .get(
        url,
        {
          headers: {
            "x-access-token": token,
            "content-type": "application/json",
          },
        }
      )
      .then((res) => {
        setLoadingTable(false);
        const pagamentosRecentes = Array.isArray(res?.data?.pagamentosRecentes) ? res.data.pagamentosRecentes : [];
        const pagamentosFiltrados = filtrarPagamentosPorPeriodo(pagamentosRecentes);
        setTotal(Number(res.data.valorTotal) || 0);
        setTotais({
          credito: res.data.valorCartaoCredito,
          debito: res.data.valorCartaoDebito,
          pix: res.data.valorPix,
          especie: res.data.valorCash,
          quantidade: res.data.qtd,
          totalGeral: res.data.valorTotal,
          totalBruto: Number(res.data.totalBruto) || 0,
          totalLiquido: Number(res.data.totalLiquido) || 0,
          totalEstorno: Number(res.data.totalEstorno) || 0
        })
        setTaxas(calcularTaxasPorTipo(pagamentosFiltrados));
        console.log(res.data)
        setListCanals(pagamentosFiltrados);
        if (dataInicio && dataFim) {
          getResumoTodasMaquinas(filtro);
        }
      })
      .catch((err) => {
        setLoadingTable(false);
        setTaxas({ PIX: 0, CREDITO: 0, DEBITO: 0 });
        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message:
              "A sua sessão expirou, para continuar faça login novamente.",
          });
          if (dataUser.key === "ADMIN") {
            navigate(links.ADMIN_SIGNIN);
            setDataUser(null);
          } else {
            navigate(links.SIGNIN);
            setDataUser(null);
          }
        }
      });
  };

  const columns = [
    {
      title: "Data",
      dataIndex: "data",
      key: "data",
      width: 400,
      render: (data) => (
        <span>{moment(data).format('DD/MM/YYYY - HH:mm')}</span>
      ),
    },
    {
      title: "Forma de pagamento",
      dataIndex: "tipo",
      key: "tipo",
      render: (tipo, record) => {
        const tipoValue = String(tipo || "").trim().toLowerCase();
        return (
        <span>
          {tipoValue === "bank_transfer" || tipoValue === "11" || tipoValue === "pix"
            ? "PIX"
            : tipoValue === "account_money" || tipoValue === "conta mercado pago"
              ? "Conta Mercado Pago"
              : tipoValue === "cash"
              ? "Especie"
              : tipoValue === "debit_card" || tipoValue === "8"
                ? "Débito"
                : tipoValue === "credit_card" || tipoValue === "prepaid_card" || tipoValue === "1"
                  ? "Crédito"
                  : ""}
        </span>
      );
      },
    },
    {
      title: "Valor",
      dataIndex: "valor",
      key: "valor",
      render: (valor) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(valor),
    },
    {
      title: "Taxas",
      dataIndex: "taxas",
      key: "taxas",
      render: (taxas) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(taxas),
    },
    {
      title: "Máquina",
      dataIndex: "maquinaNome",
      key: "maquinaNome",
    },
    {
      title: "Máquina Descrição",
      dataIndex: "maquinaDescricao",
      key: "maquinaDescricao",
    },
    {
      title: "Operadora",
      dataIndex: "operadora",
      key: "operadora",
    },
    {
      title: "Identificador",
      dataIndex: "mercadoPagoId",
      key: "mercadoPagoId",
    },
  ];

  return (
    <div className="Admin_PagamentosSearch_container">
      {isLoading && <LoadingAction />}
      <div className="Admin_PagamentosSearch_header">
        <div className="Admin_Dashboard_staBlockTitle">
          Pagamentos Recentes {modoResumo === "todas" ? "(todas as máquinas)" : maquina.id ? 'para máquina ' + maquinas.filter((d) => d.id == maquina.id)[0].nome : ''}
        </div>
        <Button
          className="Admin_PagamentosSearch_header_back"
          onClick={() =>
            navigate(`${links.DASHBOARD_FORNECEDOR}`)
          }
        >
          VOLTAR
        </Button>
      </div>
      <div className="Admin_PagamentosSearch_filter">
        <div className="Admin_PagamentosSearch_datePicker">
          <button
            type="button"
            className="ik-native-select"
            style={{
              border: '1px solid rgba(255, 255, 255, 0.14)',
              borderRadius: '0.25rem',
              textAlign: 'center',
              width: '100%',
              height: '50%',
              padding: '12px',
              fontSize: '16px',
              appearance: 'none',
              backgroundColor: 'rgba(255, 255, 255, 0.04)',
              color: 'rgba(233, 242, 255, 0.85)',
              cursor: 'pointer',
            }}
            onClick={() => {
              const hoje = moment().format("YYYY-MM-DD");
              setModoResumo("todas");
              setMaquina({ id: "", nome: "" });
              setFiltro("hoje");
              setDataInicio(hoje);
              setDataFim(hoje);
              setListCanals([]);
              setTotal(0);
              setTotais({
                especie: 0,
                pix: 0,
                debito: 0,
                credito: 0,
                quantidade: 0,
                totalGeral: 0,
                totalBruto: 0,
                totalLiquido: 0,
                totalEstorno: 0,
              });
              setTotaisTodasMaquinas({ especie: 0, pix: 0, debito: 0, credito: 0 });
              setTaxas({ PIX: 0, CREDITO: 0, DEBITO: 0 });
              setTaxasTodasMaquinas({ PIX: 0, CREDITO: 0, DEBITO: 0 });
            }}
          >
            Resumo todas as máquinas
          </button>
        </div>
        <div className="Admin_PagamentosSearch_datePicker">
          <Form.Select
            className="ik-native-select"
            style={{
              border: '1px solid rgba(255, 255, 255, 0.14)',
              borderRadius: '0.25rem',
              textAlign: 'center',
              width: '100%',
              height: '50%',
              padding: '12px',
              fontSize: '16px',
              appearance: 'none', // Remove estilos nativos do select
              backgroundColor: 'rgba(255, 255, 255, 0.04)',
              color: 'rgba(233, 242, 255, 0.85)',
              cursor: 'pointer',
            }}
            value={maquina.id}
            id="tipoPagamento"
            name="tipoPagamento"
            onChange={(e) => {
              const selectedId = e.target.value;
              const selectedMachine = maquinas.find((m) => String(m?.id) === String(selectedId));
              setModoResumo("maquina");
              setMaquina({
                id: selectedId,
                nome: selectedMachine?.nome || "",
              });
              // getData(filtro)
            }}
          >
            <option value="">Escolha a máquina</option>
            {maquinas.map((maquina) =>
              <option value={maquina.id} about={maquina.nome}>{maquina.nome}</option>
            )}
          </Form.Select>
        </div>
        {modoResumo === "todas" || maquina.id ?
          <>
            <div className="Admin_PagamentosSearch_datePicker">
              <Radio.Group
                defaultValue="mesatual"
                value={filtro}
                onChange={(e) => setFiltro(e.target.value)}
              >
                <Radio.Button value="hoje">Hoje</Radio.Button>
                <Radio.Button value="mesatual">Mês Atual</Radio.Button>
                <Radio.Button value="mespassado">Mês Passado</Radio.Button>
                <Radio.Button value="periodo">Período</Radio.Button>
              </Radio.Group>
            </div>
            <div className="Admin_PagamentosSearch_datePicker">
              <RangePicker
                disabled={filtro !== "periodo"}
                placeholder={["Data Inicial", "Data Final"]}
                onChange={(dates, dateStrings) => {
                  setDataInicio(dateStrings ? dateStrings[0] : null);
                  setDataFim(dateStrings ? dateStrings[1] : null);
                }}
              />
            </div>
            <Button
              className="Admin_PagamentosSearch_button"
              onClick={() => {
                if (isLoading) return;
                if (modoResumo === "todas") {
                  getDataTodasMaquinas(filtro);
                } else {
                  getData(filtro);
                }
              }}
            >
              BUSCAR RELATÓRIO
            </Button>
          </>
          :
          null
        }

      </div>

      <div className="Admin_PagamentosSearch_body">
        <div className="Admin_PagamentosSearch_content">
          <div style={{ marginBottom: 10, color: "rgba(233, 242, 255, 0.7)", fontWeight: 600 }}>
            Resumo do período:{" "}
            {dataInicio && dataFim
              ? `${moment(dataInicio).format("DD/MM/YYYY")} - ${moment(dataFim).format("DD/MM/YYYY")}`
              : "-"}
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "20px" }}>
            <div className="card-total">
              <span className="card-total-title">Espécie</span>
              <span className="card-total-value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(totais.especie)}</span>
            </div>
            <div className="card-total">
              <span className="card-total-title">PIX</span>
              <span className="card-total-value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(totais.pix)}</span>
              <div className="card-total-tax">Taxa: {Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(taxas.PIX || 0)}</div>
            </div>
            <div className="card-total">
              <span className="card-total-title">Débito</span>
              <span className="card-total-value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(totais.debito)}</span>
              <div className="card-total-tax">Taxa: {Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(taxas.DEBITO || 0)}</div>
            </div>
            <div className="card-total">
              <span className="card-total-title">Crédito</span>
              <span className="card-total-value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(totais.credito)}</span>
              <div className="card-total-tax">Taxa: {Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(taxas.CREDITO || 0)}</div>
            </div>
          </div>

          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginBottom: "20px" }}>

            <div className="card-total">
              <span className="card-total-title">Total Bruto</span>
              <span className="card-total-value" style={{ fontWeight: "bold", color: "#0c8ce9" }}>{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(totais.totalBruto)}</span>
            </div>
            <div className="card-total">
              <span className="card-total-title">Total Estornos</span>
              <span className="card-total-value" style={{ fontWeight: "bold", color: "#ff4d4f" }}>{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(totais.totalEstorno)}</span>
            </div>
            <div className="card-total">
              <span className="card-total-title">Total Taxas</span>
              <span className="card-total-value" style={{ fontWeight: "bold", color: "#ff4d4f" }}>- {Number((taxas.PIX + taxas.CREDITO + taxas.DEBITO).toFixed(2))}</span>
            </div>
            <div className="card-total">
              <span className="card-total-title">Total Líquido</span>
              <span className="card-total-value" style={{ fontWeight: "bold", color: "#28a745" }}>{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(totais.totalLiquido)}</span>
            </div>
            <div className="card-total">
              <span className="card-total-title">Qtd. Vendas</span>
              <span className="card-total-value">{totais.quantidade}</span>
            </div>
          </div>

          {modoResumo === "todas" && dataInicio && dataFim ? (
            <div style={{ marginBottom: "20px" }}>
              <div className="card-total" style={{ width: "100%" }}>
                <span className="card-total-title">Resumo (todas as máquinas)</span>
                <div style={{ height: 240, marginTop: 10 }}>
                  {loadingTotaisTodasMaquinas ? (
                    <div style={{ color: "rgba(233, 242, 255, 0.65)", fontWeight: 600 }}>Carregando gráfico...</div>
                  ) : (
                    <Pie data={getPieChartDataAllMachines()} options={pieOptionsAllMachines} />
                  )}
                </div>
              </div>
            </div>
          ) : null}

          <div
            className="Admin_PagamentosSearch_titleList_main"
            style={{ marginBottom: "10px" }}
          >
            <div className="Admin_PagamentosSearch_titleList">
              <div style={{ marginLeft: "20px" }}>Total Listado</div>
              <div className="Admin_PagamentosSearch_nbList">
                {Intl.NumberFormat("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                }).format(total)}
              </div>
            </div>
          </div>
          <Table
            columns={columns}
            dataSource={listCanals}
            pagination={true}
            loading={loadingTable}
            locale={{
              emptyText: <div>Não foram encontrados resultados para sua pesquisa.</div>,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PagamentosCliente;
